import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AdminHeader } from '../admin-header/admin-header';
import { AdminSidebar } from '../admin-sidebar/admin-sidebar';

@Component({
  selector: 'app-transactions',
  standalone: true,
  imports: [CommonModule, FormsModule, AdminHeader, AdminSidebar],
  templateUrl: './transactions.html',
  styleUrls: ['./transactions.css']
})
export class TransactionsComponent implements OnInit {
  transactions: any[] = [];
  filtered: any[] = [];
  search = '';
  type = 'all';

  constructor(private http: HttpClient) {}

  ngOnInit(): void {
    this.fetchTransactions();
  }

  fetchTransactions() {
    this.http.get<any[]>('http://localhost:5002/api/transactions').subscribe(data => {
      this.transactions = data;
      this.filtered = data;
    });
  }

  filter() {
    const query = this.search.toLowerCase();
    this.filtered = this.transactions.filter(t =>
      (this.type === 'all' || t.type === this.type) &&
      (t.drug_name?.toLowerCase().includes(query) ||
       t.store_name?.toLowerCase().includes(query) ||
       t.staff_name?.toLowerCase().includes(query))
    );
  }
}
